/** Heading fonts an author can pick in Builder (COM-945 Feature Hero). */
export type HeadingFont = "grotesque" | "serif" | "sans";

/** Builder dropdown label → font. "Site default" leaves it to the site. */
export const HEADING_FONT_OPTIONS = {
  "Site default": undefined,
  "Volkolak Grotesque": "grotesque",
  "Volkolak Serif": "serif",
  "Volkolak Sans Serif": "sans",
} as const satisfies Record<string, HeadingFont | undefined>;

export const HEADING_FONT_CLASS: Record<HeadingFont, string> = {
  grotesque: "font-grotesque",
  serif: "font-serif",
  sans: "font-display",
};

export const toHeadingFont = (value?: string): HeadingFont | undefined =>
  value && value in HEADING_FONT_OPTIONS
    ? HEADING_FONT_OPTIONS[value as keyof typeof HEADING_FONT_OPTIONS]
    : undefined;
